export const workshopsListItems = [
  {
    id: 1,
    text: 'Narrative designer vs game writer: stating the difference',
  },
  {
    id: 2,
    text: 'Environmental storytelling',
  },
  {
    id: 3,
    text: 'Writing dialogues for games',
  },
  {
    id: 4,
    text: 'The role of narrative design',
  },
  {
    id: 5,
    text: 'Basics of story design',
  },
  {
    id: 6,
    text: 'Character creation',
  },
  {
    id: 7,
    text: 'How to handle production process when writing a game',
  },
];
